<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
export default {
  name: "App",
  mounted() {
    // var script = document.createElement("script");
    // script.src = "https://res.wx.qq.com/open/js/jweixin-1.6.0.js";
    // document.head.appendChild(script);
    // 	sessionStorage.removeItem( 'firstHref' )
    // this.$nextTick(() => {
    sessionStorage.setItem("firstHref",window.location.href);
    // })
    console.log(Https);

    let Https = window.location.href;


  },
  created() {},
  methods: {
  },
};
</script>

<style>
/deep/ .el-image-viewer__canvas {
  height: 100%;
  width: 100%;
  /deep/ img {
    height: 100%;
    width: 100%;
    object-fit: contain;
  }
}
/* .Launch {
  width: 46%;
  margin: 40px auto 40px;
} */
uni-page-body,
html,
body {
  height: 100%;
  background-color: #efefef;
}

img {
  width: 100%;
  height: 100%;
}

/* 单行超出隐藏 */
.text_com {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 多行超出隐藏 */
.work_font {
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

/* 消除滚动条 */
::-webkit-scrollbar {
  width: 0;
  height: 0;
  color: transparent;
}

.puhui {
  font-family: puhui;
}

.display {
  display: flex;
}

.displayBetween {
  display: flex;
  justify-content: space-between;
}

.footer_temp {
  width: 100%;
  padding: 20px 24px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  position: fixed;
  bottom: 0;
  box-sizing: border-box;
  z-index: 99;
}

.footer_btn {
  width: 265px;
  height: 42px;
  line-height: 42px;
  background: #fa5151;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  box-sizing: border-box;
  border-radius: 21px;
}

::v-deep .uicon-star-fill {
  color: #ffc300 !important;
}
.assist-popup {
  background: #fff7ee;
  box-sizing: border-box;
  padding: 12px 20px;
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 999;
  color: #fd9d28;
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  border: none !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue